/**
 * Extrae el primer número de un texto de nivel (ej. `"Nivel 2 - Creador"`).
 *
 * @param text - texto del nivel; `null`/vacío devuelve `null`
 * @returns el número encontrado, `0` si el texto no tiene dígitos, o `null` si no hay texto
 */
export function extractLevel(text: string | null): number | null {
  if (!text) return null;
  const match = text.match(/(\d+)/);

  if (match && match[1]) {
    return parseInt(match[1], 10);
  }

  return 0;
}
